import { GuestOrderCheckBoxProps } from '../interface/interface';

export default function GuestOrderCheckBox(
  props: Readonly<GuestOrderCheckBoxProps>,
) {
  return (
    <>
      <input
        type="checkbox"
        className="ml-4"
        checked={!!props?.guestOrderFilter}
        onChange={() => {
          props.setGuestOrderFilter!((prev) => !prev),
            props.setFirstOrderFilter!(false);
        }}
      />
      <p className="text-base text-primary-blue-500 ml-1">Guest Order</p>
    </>
  );
}
